import { render } from "./TheFile.vue?vue&type=template&id=d713c7c6&scoped=true&ts=true&lang=html"
import script from "./TheFile.vue?vue&type=script&lang=ts"
export * from "./TheFile.vue?vue&type=script&lang=ts"

import "./TheFile.vue?vue&type=style&index=0&id=d713c7c6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d713c7c6"]])

export default __exports__